import api from '../config/axiosConfig';

export const TypesService = {
    get: async ({ token, table }) => {
        try {
            const response = await api.get('/types', {
                headers: { Authorization: `Bearer ${token}` },
                params: { table },
            });
            return response.data;
        } catch (error) {
            console.error('Error en TypesService.get:', error);
            throw error;
        }
    },
};
